module.exports = __webpack_public_path__ + "img/招标代理流程专业服务.82a5d149.png";